(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodSortDropdown', sodSortDropdown);

    function sodSortDropdown() {
        return {
            restrict: 'E',
            controller: sodSortDropdownCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                options: '=',
                getSort: '=?',
                toggleRefresh: '=?'
            },
            templateUrl: 'common/components/sod-sort-dropdown'
        };
    }

    function sodSortDropdownCtrl(lodash, $filter) {
        var vm = this;

        this.$onInit = function() {
            vm.constructQueryText = constructQueryText;
            vm.getSort = getSort;
            vm.select = select;
            vm.change_direction = change_direction;

            vm.directionText = '';

            vm.selected_option = lodash.get(vm.options, 'default', null);
            vm.selected_direction = lodash.get(vm.options, 'default.dir', 'asc');
        }

        function constructQueryText() {
            if (vm.selected_option === null) {
                return vm.options.label.no_sort;
            } else {
                vm.direction_text = lodash.get(vm.options.label.direction, vm.selected_direction, null);
                return $filter('stringFormat')(vm.options.label.sort, [vm.selected_option.label])
            }
        }

        function getSort() {
            if (vm.selected_option === null) {
                return [];
            }
            return [
                angular.extend(vm.selected_option, { dir: vm.selected_direction })
            ];
        }

        function select(option) {
            if (option.id !== vm.selected_option.id) {
                vm.selected_direction = null;
            }

            if (lodash.isEmpty(vm.selected_direction)) {
                vm.selected_direction = lodash.get(option, 'default_direction', 'asc');
            } else {
                vm.selected_direction = (vm.selected_direction === 'asc') ? 'desc' : 'asc';
            }
            vm.selected_option = option;
            if (typeof vm.toggleRefresh === typeof function() {}) {
                vm.toggleRefresh();
            }
            vm.togglePopover();
        }

        function change_direction() {
            vm.selected_direction = (vm.selected_direction === 'asc') ? 'desc' : 'asc';
            if (typeof vm.toggleRefresh === typeof function() {}) {
                vm.toggleRefresh();
            }
        }
    }
})();